import { render } from "./Butiran.vue?vue&type=template&id=20c4be04"
import script from "./Butiran.vue?vue&type=script&lang=js"
export * from "./Butiran.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__